/* eslint-disable no-lone-blocks */
/* eslint-disable no-unused-expressions */
/** @namespace Tigerone/Util/Script/importScript */
export const importScript = (resourceUrl, scriptId, callback = null) => {
    const script = document.createElement('script');
    script.src = resourceUrl;
    script.id = scriptId;
    script.async = true;
    if (callback) {
        script.onload = callback;
    }
    document.head.appendChild(script);
};

/** @namespace Tigerone/Util/Script/getHreflangLinks */
export const getHreflangLinks = (location) => {
    const baseUrl = location.origin;
    const basePath = location.pathname.split('/').slice(2).join('/') || '';

    const languages = [
        { hrefLang: 'en-us', pathSuffix: '/us-en/' },
        { hrefLang: 'en-gb', pathSuffix: '/uk-en/' },
        { hrefLang: 'fr-fr', pathSuffix: '/eu-fr/' },
        { hrefLang: 'de-de', pathSuffix: '/eu-de/' },
        { hrefLang: 'en-za', pathSuffix: '/za-en/' },
        { hrefLang: 'pl-pl', pathSuffix: '/eu-pl/' },
        { hrefLang: 'x-default', pathSuffix: '/us-en/' }
    ];

    return languages.map(({ hrefLang, pathSuffix }) => ({
        rel: 'alternate',
        href: `${baseUrl}${pathSuffix}${basePath}`,
        hrefLang
    }));
};

/** @namespace Tigerone/Util/Script/removeScript */
export const removeScript = (scriptId) => {
    const s = document.getElementById(scriptId);
    if (s) {
        document.head.removeChild(s);
    }
};

/** @namespace Tigerone/Util/Script/importLink */
export const importLink = (rel, href, linkId, hrefLang = '', class_name) => {
    const link = document.createElement('link');
    link.rel = rel;
    link.href = href;
    link.id = linkId;
    if (class_name) {
        { hrefLang && link.setAttribute('hrefLang', hrefLang); }
        link.className = class_name;
        document.head.appendChild(link);
    } else {
        document.head.appendChild(link);
    }
};
